<template>
  <div class="product-card-image">
    <a
      :href="href"
      :class="{
        'product-card-image__double': props.images.length >= 2,
        'product-card-image__single': props.images.length === 1
      }"
      @click.prevent="handleClick"
    >
      <BaseImage
        class="product-card-image__img"
        :class="imageClass"
        size="300x300"
        :name="images[0]"
        :alt="`${productName} - ${$t('common.photo')} 1`"
        :title="`${$t('product.buy')} ${productName} - ${$t('common.photo')} 1`"
        :width="width"
        :height="height"
        :loading="index && index < 4 ? 'eager' : 'lazy'"
      />
      <BaseImage
        v-if="images.length >= 2"
        class="product-card-image__img-two show-from-desktop"
        :class="imageClass"
        size="300x300"
        :name="images[1]"
        :alt="`${productName} ${domain} - ${$t('common.photo')} 1`"
        :title="`${productName} ${$t('product.price_on')} ${domain} - ${$t('common.photo')} 1`"
        :width="width"
        :height="height"
      />
    </a>

    <div
      v-if="showLabel"
      class="product-card-image__label"
      :class="{
        'product-card-image__label--was-sold': wasSold
      }"
    >
      <template v-if="wasSold">{{ $t('offers.sold') }}</template>
    </div>
  </div>
</template>

<script lang="ts" setup>
type Emits = {
  (e: 'click'): void
}

type Props = {
  href: string
  inStock: boolean
  wasSold: boolean
  images?: string[]
  productName?: string
  index?: number | null
  width?: string
  height?: string
}

const props = withDefaults(defineProps<Props>(), {
  images: () => [],
  productName: '',
  width: '100%',
  height: '100%'
})
const emit = defineEmits<Emits>()

const { domain } = useRuntimeConfig().public

const showLabel = computed(() => {
  return props.wasSold
})

const imageClass = computed(() => {
  return {
    'product-card-image__img--opacity': showLabel.value
  }
})


const handleClick = () => {
  emit('click')
}

</script>

<style lang="scss">
.product-card-image {
  $root: &;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: relative;

  @media only screen and (max-width: 520px) {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__label {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
    min-width: 85%;
    text-align: center;
    border-radius: 4px;
    padding: 10px 15px;
    color: #161616;
    background-color: #fff;
    z-index: 1;

    &--was-sold {
      color: #DE1C24;
      background-color: rgba(#fff, 0.7);
      border: solid 1px #DE1C24;
    }
  }

  &__img,
  &__img-two {
    display: block;
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;

    &--opacity {
      opacity: 0.4;
    }
  }

  &__single {
    display: block;
    width: 100%;
    height: 100%;
  }

  &__double {
    display: block;
    width: 100%;
    height: 100%;

    #{$root}__img-two {
      position: absolute;
      visibility: hidden;
      object-fit: contain;
      top: 0;
    }

    &:hover {
      @media only screen and (min-width: 1024px) {
        #{$root}__img {
          visibility: hidden;
        }
        #{$root}__img-two {
          visibility: visible;
        }
      }
    }
  }
}
</style>
